/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Buildhover_Created1Inputs */

const id_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat`)
};

const ms_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicipta`)
};

const da_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettet`)
};

const de_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

const en_us2_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const es_es2_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

const es_mx2_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

const fil_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginawa`)
};

const fr_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créée`)
};

const it_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creata`)
};

const hu_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozva`)
};

const nl_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangemaakt`)
};

const no_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettet`)
};

const pl_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utworzono`)
};

const pt_br2_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado`)
};

const pt_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado`)
};

const ro_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creat`)
};

const fi_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luotu`)
};

const sv_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapad`)
};

const vi_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo`)
};

const tr_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma`)
};

const cs_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno`)
};

const bg_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Създадено`)
};

const ru_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано`)
};

const uk_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створено`)
};

const ar_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्मित`)
};

const th_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างเมื่อ`)
};

const ja_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const zh_hant1_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立於`)
};

const ko_home_buildhover_created1 = /** @type {(inputs: Home_Buildhover_Created1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성됨`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Home_Buildhover_Created1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_buildhover_created1 = /** @type {((inputs?: Home_Buildhover_Created1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Buildhover_Created1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_buildhover_created1(inputs)
	if (locale === "ms") return ms_home_buildhover_created1(inputs)
	if (locale === "da") return da_home_buildhover_created1(inputs)
	if (locale === "de") return de_home_buildhover_created1(inputs)
	if (locale === "en-US") return en_us2_home_buildhover_created1(inputs)
	if (locale === "es-ES") return es_es2_home_buildhover_created1(inputs)
	if (locale === "es-MX") return es_mx2_home_buildhover_created1(inputs)
	if (locale === "fil") return fil_home_buildhover_created1(inputs)
	if (locale === "fr") return fr_home_buildhover_created1(inputs)
	if (locale === "it") return it_home_buildhover_created1(inputs)
	if (locale === "hu") return hu_home_buildhover_created1(inputs)
	if (locale === "nl") return nl_home_buildhover_created1(inputs)
	if (locale === "no") return no_home_buildhover_created1(inputs)
	if (locale === "pl") return pl_home_buildhover_created1(inputs)
	if (locale === "pt-BR") return pt_br2_home_buildhover_created1(inputs)
	if (locale === "pt") return pt_home_buildhover_created1(inputs)
	if (locale === "ro") return ro_home_buildhover_created1(inputs)
	if (locale === "fi") return fi_home_buildhover_created1(inputs)
	if (locale === "sv") return sv_home_buildhover_created1(inputs)
	if (locale === "vi") return vi_home_buildhover_created1(inputs)
	if (locale === "tr") return tr_home_buildhover_created1(inputs)
	if (locale === "cs") return cs_home_buildhover_created1(inputs)
	if (locale === "bg") return bg_home_buildhover_created1(inputs)
	if (locale === "ru") return ru_home_buildhover_created1(inputs)
	if (locale === "uk") return uk_home_buildhover_created1(inputs)
	if (locale === "ar") return ar_home_buildhover_created1(inputs)
	if (locale === "hi") return hi_home_buildhover_created1(inputs)
	if (locale === "th") return th_home_buildhover_created1(inputs)
	if (locale === "ja") return ja_home_buildhover_created1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_buildhover_created1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_buildhover_created1(inputs)
	return ko_home_buildhover_created1(inputs)
});
export { home_buildhover_created1 as "home.buildHover.created" }